module.exports = __webpack_public_path__ + "img/milk-box.512f17f2.svg";